export enum PurchaseTypeVo {
  /**
   * 소장
   */
  Buy = 'buy',
  /**
   * 대여
   */
  Rent = 'rent',
  /**
   * 미구매
   */
  NotPurchased = 'not_purchased',
  /**
   * 세트 소장
   */
  SetBuy = 'set_buy',
  /**
   * 세트 대여
   */
  SetRent = 'set_rent',
}
